import { SvgIcon } from "@mui/material";

const Project = (props) => {
  return (
    <SvgIcon viewBox="0 0 16 16" {...props}>
      <path
        d="M1 4.3125C1 3.58762 1.58762 3 2.3125 3H9.75V7.375H2.3125C1.58762 7.375 1 6.78711 1 6.0625V4.3125ZM1 10.4375C1 9.71289 1.58762 9.125 2.3125 9.125H6.25V13.5H2.3125C1.58762 13.5 1 12.9121 1 12.1875V10.4375Z"
        fill="#738499"
      />
      <path
        d="M9.75 5.625H13.25V4.75H9.75V3H13.6875C14.4121 3 15 3.58762 15 4.3125V6.0625C15 6.78711 14.4121 7.375 13.6875 7.375H9.75V5.625ZM6.25 11.75H13.25V10.875H6.25V9.125H13.6875C14.4121 9.125 15 9.71289 15 10.4375V12.1875C15 12.9121 14.4121 13.5 13.6875 13.5H6.25V11.75Z"
        fill="#DCE5F0"
      />
    </SvgIcon>
  );
};

export default Project;
